<template>
	<div>
		<el-input :placeholder="placeholder" class="is-border smsInput" style="margin-bottom: 15px;" v-model="filterText">
			<BaseIcon slot="prefix" name="search" class="el-input__icon" />
		</el-input>
		<el-form label-position="top" class="isWrap">
			<el-form-item style="min-height: 250px" :class="$style['services-wrap']">
				<div :class="$style.dialogTitle">
					<el-checkbox v-model="checkAll" :indeterminate="isIndeterminate"
						style="margin-left: 5px; margin-top: 10px; margin-bottom: 5px" @change="handleCheckAllChange">全
						選
					</el-checkbox>
				</div>
				<template v-if="dialogType === 'person'">
					<el-checkbox-group v-model="catchItems" :class="$style.services" @change="handleCheckedPrepaid">
						<el-checkbox v-for="(item, index) in filterList" :key="index" :label="item.id" border>
							{{ item.name }} - <span :class="$style['services__title']">{{ item.title }}</span>
						</el-checkbox>
					</el-checkbox-group>
				</template>

				<template v-if="dialogType === 'service'">
					<el-checkbox-group v-model="catchItems" :class="$style.services" @change="handleCheckedPrepaid">
						<el-checkbox v-for="(item, index) in filterList" :key="index" :label="item.id" border>
							{{ item.name }} - <span :class="$style['services__title']">{{ item.title }}</span>
						</el-checkbox>
					</el-checkbox-group>
				</template>

			</el-form-item>
		</el-form>

		<div class="btn-group-inline">
			<el-button class="is-round" @click="cancel">取消</el-button>
			<el-button class="is-round" type="primary" @click="save">儲存</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DialogTemplate',
	data() {
		return {
			filterText: '', // 篩選資料
			isIndeterminate: false, // 不確定狀態
			checkAll: false, // 全選
			allList: [], // 所有列表
			catchItems: [], // 選到的資料
		};
	},
	props: {
		placeholder: {
			type: String,
			default: ''
		},
		itemList: {
			type: Array,
			default: () => []
		},
		dialogType: {
			type: String,
			default: ''
		},
		editCheckInList: {
			type: Array,
			default: () => []
		}
	},
	watch: {
		catchItems(nvl) {
		}
	},
	computed: {
		filterList() {
			return this.itemList
		}
	},
	created() { },
	mounted() { 
		if(this.editCheckInList.length > 0){
			this.editCheckInList.forEach(item => {
				this.catchItems.push(item)
			})
			this.handleCheckedPrepaid(this.catchItems)
		}
	},
	methods: {
		save() {
			this.$emit('save', this.catchItems)
		},
		cancel() {
			this.$emit('cancel')
		},
		handleCheckAllChange(val) {
			this.catchItems = val ? this.itemList.map(item => item.id) : [];
			this.isIndeterminate = false;
		},
		handleCheckedPrepaid(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.itemList.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.itemList.length;
		}
	},
	components: {},
};
</script>

<style lang="scss" module>
.services-wrap {
	border: 1px solid $color-border-for-bg-white;
	border-radius: $border-radius;
}

.services {
	padding: 15px;

	:global {
		label.el-checkbox.is-bordered {
			width: calc(50% - 10px);
			display: inline-flex;
			margin: 5px;
			align-items: center;
			height: auto;
			padding: 15px 20px 15px 15px;

			@include max-sm {
				width: 100%;
			}

			.el-checkbox__label {
				padding-left: 15px;
				width: 100%;
				overflow-x: auto;
			}

			&+.el-checkbox.is-bordered {
				margin-left: 5px;
			}

			.title,
			.meta {
				width: calc(100% - 20px);
				overflow: hidden;
				text-overflow: ellipsis;
				display: block;
			}

			.content {
				width: 100%;
			}
		}
	}

	&__title {
		color: $color-text-light;
	}
}

.dialogTitle {
	background-color: $color-line;
	padding-left: 15px;
}
</style>
